<template>
  <div class="card links-card">
    <div style="display: flex;">
      <div class="links-body">
        <div class="statBlock">
          <div class="card-header" v-if="$slots.header">
            <slot name="header"></slot>
          </div>
          <div class="card-body">
            <div v-if="linksFormatted.length > 0">
              <div v-for="(link,index) in linksFormatted" :key="index" @mouseover="getInfo(link)">
                <!-- show different things depending on what information is available -->
                <div v-if="link.name && link.url">
                  <b-popover
                    :target="'peoplePopover'+link._id+index"
                    triggers="hover"
                    placement="top"
                    custom-class="my-popover-class"
                  >
                    <div class="row">
                      <div v-if="popOvrCmpny && popOvrCmpny.image" class="col-6">
                        <img
                          v-if="popOvrCmpny.image"
                          width="120"
                          height="120"
                          :src="popOvrCmpny.image"
                        />
                      </div>
                      <div :class="popOvrCmpny && popOvrCmpny.image ? 'col-6' : 'col-12'">
                        <b>{{popOvrCmpny.name || popOvrCmpny.investor_name || popOvrCmpny.person_name}}</b>
                        <div
                          v-if="popOvrCmpny.jobTitle || popOvrCmpny.job_title || popOvrCmpny.job"
                        >{{popOvrCmpny.jobTitle || popOvrCmpny.job_title || popOvrCmpny.job}}</div>
                        <div>
                          <a
                            v-if="popOvrCmpny.url_linkedin"
                            target="_blank"
                            :href="popOvrCmpny.url_linkedin"
                          >
                            <i class="fa fa-linkedin" aria-hidden="true"></i>
                          </a>
                          <a
                            v-if="popOvrCmpny.facebook_url"
                            target="_blank"
                            :href="popOvrCmpny.facebook_url"
                          >
                            <i class="fa fa-facebook-square" aria-hidden="true"></i>
                          </a>
                          <a
                            v-if="popOvrCmpny.twitter_url"
                            target="_blank"
                            :href="popOvrCmpny.twitter_url"
                          >
                            <i class="fa fa-twitter" aria-hidden="true"></i>
                          </a>
                        </div>
                        <div
                          v-if="popOvrCmpny.funding_round && popOvrCmpny.funding_round.length > 1"
                        >
                          <b>Funding Round :</b>
                          {{popOvrCmpny.funding_round}}
                        </div>
                        <div
                          v-if="popOvrCmpny.lead_investor && popOvrCmpny.lead_investor.length > 1"
                        >
                          <b>Lead Investors :</b>
                          {{ popOvrCmpny.lead_investor}}
                        </div>
                        <div v-if="popOvrCmpny.city">City : {{popOvrCmpny.city}}</div>
                      </div>
                    </div>
                  </b-popover>
                  <a
                    :href="formatUrl(link.url)"
                    @click.prevent="download(link)"
                    :target="setTarget(link.url)"
                    style="cursor:pointer"
                    :id="'peoplePopover'+link._id+index"
                  >{{ link.name }}</a>
                </div>
                <div v-else-if="link.name">
                  <span>{{ link.name }}</span>
                </div>
                <div v-else-if="link.url">
                  <a
                    :href="formatUrl(link.url)"
                    @click.prevent="download(link)"
                    :target="setTarget(link.url)"
                    :id="'peoplePopover'+link._id+index"
                  >{{ link.url }}</a>
                </div>
              </div>
            </div>
            <div v-else>
              <span class="placeholder-text">{{ placeholderText }}</span>
            </div>
          </div>
          <a
            class="hidden"
            ref="hiddenDownloadLink"
            :href="downloadLink"
            target="_blank"
          >Download Sample</a>
          <div class="card-footer" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "./Card.vue";
import api from "../../axios_api";
import _ from "lodash";

export default {
  name: "links-card",
  components: {
    Card
  },
  computed: {
    linksFormatted() {
      return _.map(this.linksCopy, l => {
        if (!_.isNil(l.name)) l.name = _.startCase(l.name);
        if (!_.isNil(l.url)) l.url = !_.isEmpty(l.url) ? l.url : "#";
        return l;
      });
    }
  },
  props: {
    links: {
      type: Array,
      default() {
        return [];
      }
    },
    placeholderText: {
      type: String,
      default() {
        return "Click 'edit company' above to add people/documents";
      }
    }
  },
  data() {
    return {
      linksCopy: [],
      downloadLink: "",
      popOvrCmpny: {}
    };
  },
  methods: {
    formatUrl(url) {
      // make sure it starts w/ http(s)
      if (url.length > 1) {
        if (!_.startsWith(url, "http")) url = "http://" + url;
        return url;
      } else return "#/companyProfile";
    },
    getInfo(item) {
      if (this.linksCopy && this.linksCopy.length)
        this.popOvrCmpny = this.linksCopy.find(
          obj => (obj.name || obj.investor_name || obj.person_name) == item.name
        );
      if (!this.popOvrCmpny) this.popOvrCmpny = item;
    },
    setTarget: function(url) {
      return url.length > 1 ? "_blank" : "_self";
    },
    async download(item) {
      let self = this;
      if (item.s3_path) {
        let urlData = await api
          .post(`/file/download`, {
            encrypt: {
              data: {
                s3_path: item.s3_path
              }
            }
          })
          .catch(e => {
            console.error("error: ", e);
          });
        if (
          urlData &&
          urlData.data &&
          urlData.data.encrypt &&
          urlData.data.encrypt.url
        ) {
          // window.open(urlData.data.encrypt.url);
          this.downloadLink = urlData.data.encrypt.url;

          setTimeout(() => {
            self.$refs.hiddenDownloadLink.click();
          });
        }
      } else {
        this.downloadLink = item.url;
        setTimeout(() => {
          self.$refs.hiddenDownloadLink.click();
        });
      }
    }
  },
  mounted() {
    // do a clone of the links passed in
    this.linksCopy = _.cloneDeep(this.links);
  },
  watch: {
    links: function(newVal) {
      this.linksCopy = _.cloneDeep(this.links);
    }
  }
};
</script>
<style>
.links-card {
  height: calc(100% - 30px);
}

/*.edit-button {
    display: block !important;
    width: calc(100% - 10px);
    text-align: center;
    border-top: 1px solid #dfdfdf;
    font-size: 0.8em;
    margin-bottom: 5px;
    margin-left: 5px;
    margin-top: 30px;
}*/

.links-body {
  width: 100% !important;
}

.placeholder-text {
  color: #bfbfbf;
}
.my-popover-class {
  margin-top: -20%;
}

/*.card-header {
  display: flex;
}*/
</style>
